<template lang="pug">
  include ../mixins
  div.pos--relative
    ui-preloader(
      :class="{'is-active': isLoad}"
      :is-white="true"
      loader-class="loader--variant_absolute"
    )
    validation-observer(
      tag="form"
      ref="observer"
      v-slot="{ errors }"
      @submit.prevent="validateBeforeSubmit"
    )
      +b.ls-card--color_accent-2.--border_3sm.--space_1
        location-form(
          :options="options"
          :formdata="formdata"
        )
      date-form(
        :formdata="formdata"
        :test-days-list="testDaysList"
      )
      +b.ls-card--color_accent-1.--border_3sm.--space_3sm.ma--top_md(ref="contact" v-if="isShowContactForm")
        test-contact-form.ma--custom_sm(
          :formdata="formdata"
        )
          template
            cell(cols="12 6-sm 4-md")
              bem-button.ma--top_sm(
                width="full"
                block="ls-button"
                appearance="yellow-arrow"
                :disabled="isLoad"
                @event="validateBeforeSubmit()"
              ) {{_('відіслати')}}
        //- row(justify="between" align="start" space="sm")
        //-   cell(cols="12 6-sm 8-md")
        privacy-rules.ma.ma--bottom_sm-till-xl(
          :rules-terms="objectItem.rules"
          :privacy="objectItem.privacy"
        )
</template>

<script>
import {
  ageGroupsResource,
  citiesResource,
  schoolsResource,
  testDaysResource,
} from '@/js/services/additional.service.js'
import FormMixin from '@/js/mixins/form.mixin.js'
import {
  testRequestResource,
} from '@/js/services/test.service.js'
import { getCookie } from '@/js/resource/cookie'
import UserInfoMixin from '@/js/mixins/userInfo.mixin.js'

export default {
  name: 'test-request-wrapper',

  mixins: [
    FormMixin,
    UserInfoMixin,
  ],

  components: {
    'location-form': () => import('./LocationForm.vue'),
    'date-form': () => import('./DateForm.vue'),
    'test-contact-form': () => import('./TestContactForm.vue'),
    'privacy-rules': () => import('@/js/components/Forms/PrivacyRules'),
  },

  props: {
    defaultCity: Number,
    objectItem: Object,
    userCityId: {},
    userSchoolId: {},
  },

  data() {
    return {
      formdata: {
        city: '',
        school: '',
        ageGroup: '',
        dateSlot: '',
        timeSlot: '',
        slot: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        contactPerson: '',
        dateBirthday: '',
      },
      options: {
        citiesList: [],
        schoolsList: [],
        ageGroupsList: [],
      },
      testDaysList: [],
      isShowContactForm: false,
      isLoad: false,
      cityIdFromCookie: getCookie('city_id'),
      schoolIdFromCookie: getCookie('school_id'),
    }
  },

  watch: {
    'formdata.city': {
      handler(nval) {
        if (nval) this.getSchools(nval.id)
        this.isShowContactForm = false
      },
    },
    'formdata.school': {
      handler(nval) {
        if (null !== nval && '' !== this.formdata.ageGroup) this.getTestDays()
        this.isShowContactForm = false
      },
    },
    'formdata.ageGroup': {
      handler(nval) {
        if (null !== nval && this.formdata.school) this.getTestDays()
        this.isShowContactForm = false
      },
      immediate: false,
    },
    'formdata.timeSlot': {
      handler(nval) {
        if ('' !== nval && null !== nval) {
          const timeout = 500
          this.isShowContactForm = true
          setTimeout(() => {
            this.$refs.contact.scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            })
          }, timeout)
        }
      },
    },
  },

  async mounted() {
    this.isLoad = true
    await this.getAgeGroups()
    await this.getCities()
    this.isShowContactForm = false
  },

  methods: {
    getAgeGroups() {
      return ageGroupsResource.execute().then(res => {
        const { data: { item: { items } } } = res
        this.options.ageGroupsList = items
        const [firstOption] = items
        this.formdata.ageGroup = firstOption
      })
    },
    getCities() {
      return citiesResource.execute().then(res => {
        const { data: { item: { items } } } = res
        this.options.citiesList = items
        this.preselectCity()
      })
    },
    getSchools(idCity) {
      return schoolsResource.execute({}, { idCity }).then(res => {
        const { data: { item: { items } } } = res
        this.options.schoolsList = items
        this.preselectSchool()
      })
    },
    getTestDays() {
      const idAgeGroup = this.formdata.ageGroup.id
      const idSchool = this.formdata.school.id
      return testDaysResource.execute({}, { idAgeGroup, idSchool }).then(res => {
        const { data: { item: { items } } } = res
        this.testDaysList = items
        this.isLoad = false
      })
    },

    preselectCity() {
      const [firstOption] = this.options.citiesList
      let cityId = this.defaultCity || firstOption.id
      if (this.cityIdFromCookie) {
        cityId = this.cityIdFromCookie
      } else if (this.userCityId) {
        cityId = this.userCityId
      }
      this.options.citiesList.forEach(el => {
        if (el.id === Number(cityId)) {
          this.formdata.city = el
        }
      })
    },

    preselectSchool() {
      const [firstOption] = this.options.schoolsList
      let schoolId = firstOption.id
      if (this.schoolIdFromCookie) {
        schoolId = this.schoolIdFromCookie
      } else if (this.userSchoolId) {
        schoolId = this.userSchoolId
      }
      this.options.schoolsList.forEach(el => {
        if (el.id === Number(schoolId)) {
          this.formdata.school = el
        }
      })
    },

    async send(data) {
      this.isLoad = true
      const copyData = await this.prepareData({ ...data })
      return testRequestResource.execute({}, copyData).then(res => {
        this.isLoad = false
        this.handleResponse({ res, modal: true, noFieldClearing: true })
        // /* eslint-disable prefer-destructuring */
        // this.formdata.ageGroup = this.options.ageGroupsList[0]
        // this.formdata.city = this.options.citiesList[0]
        // this.formdata.school = this.options.schoolsList[0]
        // /* eslint-enable prefer-destructuring */
        this.isShowContactForm = false
      })
    },
  },
}
</script>
